import { helpers, ls, React, ts, ui } from '_core';

type ItemProps = {
  item: helpers.resourcesSearch.ReturnItem;
  clickCallback?: () => void;
  source: 'recently-opened' | 'search-results';
};

const Item = ({ item, clickCallback, source }: ItemProps) => {
  const plural = helpers.pluralize.plural(item.resourceType);

  const clickHandler = () => {
    clickCallback();
    if (source === 'search-results') {
      ls.pushAndDropLast({
        data: item,
        path: 'recently-opened',
        stackSize: 20,
        compareFn: (a, b) =>
          (a as helpers.resourcesSearch.ReturnItem).id === (b as helpers.resourcesSearch.ReturnItem).id,
      });
    }
  };

  return (
    <div style={{ marginBottom: '-5px' }}>
      <ui.InlineItem
        resource={item}
        resourceType={item.resourceType as ts.enums.RESOURCES_TYPES_ENUM}
        to={`/${plural}/${item.id}/definition`}
        clickCallback={clickHandler}
      />
    </div>
  );
};

export default Item;
